import { gql } from '@apollo/client'

export const updateNeedByDateMutation = gql`
    mutation SetNeedByDate($quoteId: UUID!, $needByDate: Date) {
        setNeedByDate(quoteId: $quoteId, needByDate: $needByDate)
    }
`

export const createQlltSlackThread = gql`
    mutation SendQlltOptimisationNotification($quoteId: UUID!, $userId: Int!) {
        sendQlltOptimisationNotification(quoteId: $quoteId, userId: $userId) {
            url
        }
    }
`

export const updateBusinessAccountFeature = gql`
    mutation SetBusinessAccountFeature(
        $businessAccountId: UUID!
        $featureName: BusinessAccountFeatureInput!
        $isEnabled: Boolean!
    ) {
        setBusinessAccountFeature(
            businessAccountId: $businessAccountId
            featureName: $featureName
            isEnabled: $isEnabled
        ) {
            id
            businessAccountId
            featureName
            isEnabled
        }
    }
`
export const recordCltOptimizerView = gql`
    mutation RecordCltOptimizerView($quoteId: UUID!) {
        recordCltOptimizerView(quoteId: $quoteId) {
            id
            quoteId
            viewCount
            lastViewed
            createdAt
        }
    }
`

export const recordCltOptimizationMutation = gql`
    mutation RecordCltOptimization(
        $quoteModelRevisionId: UUID!
        $operation: String!
        $description: String!
        $initialCostCents: Int!
        $finalCostCents: Int!
        $initialTimeDays: Int!
        $finalTimeDays: Int!
        $initialQuantity: Int!
        $finalQuantity: Int!
    ) {
        recordCltOptimization(
            quoteModelRevisionId: $quoteModelRevisionId
            operation: $operation
            description: $description
            initialCostCents: $initialCostCents
            finalCostCents: $finalCostCents
            initialTimeDays: $initialTimeDays
            finalTimeDays: $finalTimeDays
            initialQuantity: $initialQuantity
            finalQuantity: $finalQuantity
        ) {
            id
            quoteId
            quoteModelRevisionId
            userId
            businessAccountMembershipId
            operation
            description
            initialCostCents
            finalCostCents
            initialTimeDays
            finalTimeDays
            initialQuantity
            finalQuantity
            createdAt
        }
    }
`

export const LogRequestAssistance = gql`
    mutation LogRequestAssistance($quoteId: UUID!) {
        logRequestAssistance(quoteId: $quoteId)
    }
`

export const GenerateCltOptimizerReport = gql`
    mutation GenerateCltOptimizerReport($quoteId: UUID!) {
        generateCltOptimizerReport(quoteId: $quoteId) {
            id
            quoteId
            userId
            businessAccountId
            costCentsDelta
            timeDaysDelta
            viewCount
            lastViewed
        }
    }
`
